import { ThisReceiver } from '@angular/compiler';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator'; 
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppService } from 'src/app/app.service';
import { CarsService } from 'src/app/services/cars.service';
import { UserServiceService } from 'src/app/services/user-service.service';
import { VehiculeserviceService } from 'src/app/services/vehiculeservice.service';
import { LoginserviceService } from 'src/app/services/loginservice.service';
import { Router } from '@angular/router';
import { TemplateSearchCar } from "src/app/app.models";
import { DataSearchService } from 'src/app/services/data-search.service'; 
import { MatInputModule } from '@angular/material/input';
import { DatePipe } from "@angular/common";
import { Options } from "ngx-google-places-autocomplete/objects/options/options";
import { MatSlideToggle, MatSlideToggleChange } from '@angular/material/slide-toggle';
import { ToastrService } from 'ngx-toastr';
import { VerifResponsiveService } from 'src/app/services/verif-responsive.service';


@Component({
  selector: 'app-vehicules',
  templateUrl: './vehicules.component.html',
  styleUrls: ['./vehicules.component.scss']
})
export class VehiculesComponent implements OnInit {
  
  address: string;
  geometry: object;

  options: Options = new Options({
    componentRestrictions: {
      country: "SN",
    },
  });

  public minDateStart: Date;
  public minDateEnd: Date;
  public currentDateStart?: string;
  public currentDateEnd?: string;
  public showChoice: boolean;
  public showChoiceEnd: boolean;
  public errorAdress: boolean;
  public valueDatePickerEnd?: Date;

  dateStart: any;
  dateEnd: any;
  todayWithPipe: any;
  periodStart?: string;
  periodEnd?: string;
  currentDateFormat?: string;
  templateSearchCar: TemplateSearchCar;

  index: number;
  displayedColumns: string[] = [
    "verification",
    "marque",
    "model",
    "prix",
    "date",
    "status",    
    "priority",    
    "actions",
  ];
  user: any = [];
  customerList: any;
  resultcat: any;
  idcar: number;
  result:any;
  idCars:any;
  idCarsUser:number;
  search:string;
   dats:boolean;
  show :boolean ;
 
  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  public statuses = [
    { id: 1, name: 'disponible' },
    { id: 2, name: 'indisponible' },
  ];
  public statCar = [
    { id: 1, name: 'valider' },
    { id: 2, name: 'non valider' },
  ];

  public lazyLoad: boolean = false;
  public viewType: string = "list";
  public column: number = 4;
  public p: number = 1;

  MatSlideToggleChange = {source: MatSlideToggle, checked: true}
  constructor(
    public appService: AppService,
    public appServices: UserServiceService,
    public snackBar: MatSnackBar,
    public carservice: VehiculeserviceService,
    private service:UserServiceService,
    public loginService: LoginserviceService,
    public router: Router,
    private toastr: ToastrService,
    private verifResponsiveService:VerifResponsiveService

  ) {}
  ngOnInit() {

    
    const storage = localStorage.getItem("user");
    if (storage) {
      this.idCars = JSON.parse(storage);
    }
    this.show =true ;
    this.carservice.getallvehicleAdmin().subscribe((data: any) => {
     
      this.initDataSource(data);
    
    });

    this.verifResponsiveService.confirmResponsive().subscribe((data) => {
      this.viewType = data ? 'grid' : 'list';
    });
   
  }
  public initDataSource(data: any) {
    console.log(data);
    this.resultcat = data;
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    //        this.service.UpdateUserr().subscribe((reponse:any)=>{
          
    // })
  }
  public getCar(){
    this.resultcat  =[];
        this.carservice.getallvehicleAdmin().subscribe((data: any) => {
        this.resultcat = data;
        this.idcar = data.id;
        this.dataSource = new MatTableDataSource<any>(this.resultcat);

    });
  }

  public showCar(id:number)
  {
    this.router.navigate(["admin/vehicules/show-car"],{
      queryParams: { vehicule: id },
    })
  }

   onChange($event: MatSlideToggleChange, id: number,data:any) {
    console.log(id);
     let obj = {
         vehicule_verify: $event.checked,
         id:id,
         status:data
        
     }
     console.log('obj',obj)
     if( $event.checked == true){
         console.log('obj',obj)
         this.carservice.updateCarSuper( obj).subscribe((data:any)=>{
             console.log(data);
             this.toastr.success('La validité du véhicule a été modifié avec succès');

            this.show =true ;
         },error=>{
          this.toastr.error("Oops une erreur s'est produite, veillez contacter votre Administrateur");
         }) 
     }else{
        
      this.carservice.updateCarSuper( obj).subscribe((data:any)=>{
        console.log(data);
        this.toastr.success('La validité du véhicule a été modifié avec succès');
            this.show =false ;
         },error=>{
          this.toastr.error("Oops une erreur s'est produite, veillez contacter votre Administrateur");
         }) 

     }
}
 
   public SelectionChange(event:any , datass:number){  
    let obj ={
      id:datass,
      vehicule_verify:event.value.name
    }
   
    this.carservice.updateCarSuper(obj).subscribe((data: any) => {
     
      console.log(data)
    });
    this.carservice.getallvehicleAdmin().subscribe((data: any) => {
   
      console.log(event);

  });
  }
  public onStatusSelectionChange(event:any , datass:number){  
      let obj ={
        id:datass,
        status:event.value.name
      }
    
      this.carservice.updateCarSuper(obj).subscribe((data: any) => {
        this.toastr.success('La statut du véhicule a été modifié avec succès');
      },error=>{
        this.toastr.error("Oops une erreur s'est produite, veillez contacter votre Administrateur");
      });
      this.carservice.getallvehicleAdmin().subscribe((data: any) => {
    });
  }
  public remove(id: number) {

    this.carservice.suprimeCar(id).subscribe((data) => {
      console.log(data);

      console.log(data);
    this.getCar();
    });
  }

  public edit(id: number) {
    this.router.navigate(["compte-utilisateur/mes-vehicules/edit-vehicule"], {
      queryParams: { code: id },
    });
  }
  public addressChange(address: any) {
    this.address = address.formatted_address;

    this.geometry = address.geometry;
  }
     /**
      * Search element into all catégories
      *
      * @param filtervalue
      */
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }  

  public changePrioritycar(event:any , idcar:number)
  {

    console.log(event.value);
    let obj ={
      id:idcar,
      priority:event.value
    }
   
   this.carservice.changePriorityCar(obj).subscribe((data: any) => {
      this.getCar();
      console.log(data);
    });
    
  }

  refresh() {
    this.getCar(); 
  }
   
  changeViewType(viewType:string)
  {
    this.viewType = viewType;
  }

}
